<template>
<div class="sb-date-picker sb-date-picker sb-date-picker sb-date-picker">
  <date-picker v-model="value" :config="options" @dp-change="onChange" :disabled="disabled"></date-picker>
</div>
</template>
<script>
import DatePicker from '../vendor/BootstrapDatePicker'
import moment from 'moment'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
export default {
  name: 'SbDatePicker',
  components: {
    'date-picker': DatePicker
  },
  data () {
    return {
    }
  },
  props: {
    options: {
      type: Object,
      default: {}
    },
    selectedValue: {
      type: String,
      default: moment().format('MM/DD/YYYY')
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$emit('selectedDate', this.selectedValue)
  },
  computed: {
    value: {
      get () {
        return this.selectedValue
      },
      set (val) {
        this.$emit('selectedDate', val)
      }
    }
  },
  methods: {
    onChange () {
    }
  }
}
</script>
<style lang="scss" scoped>
.sb-date-picker {
 position: relative;
 z-index: 1;
 ::v-deep .bootstrap-datetimepicker-widget {
    color: #2470AF !important;
 }
}
</style>


